import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(SplitText) 

export const initSplitText = () => {
	document.fonts.ready.then(() => {
		const split = SplitText.create('[data-split]', {
			type: 'lines',
			linesClass: 'line++',
			aria: 'none',
			mask: 'lines'
		})
	})
}

export default () => {}